@if(!showForm()){
<button class="btn btn-standard" (click)="showFormFunc(true)">Add an Email</button>
}

<p class="text-danger ms-1 mt-2">{{personDialogDataService.emailErrorMsg()}}</p>

<div class="d-flex align-items-baseline gap-2" [class.d-none]="!showForm()">
	<common-email-field [field]="email()" class="flex-grow-1"></common-email-field>
	<common-button-row [center]="true" class="">
		<button #emailFormSaveBtn class="btn btn-primary">
			<i class="fa-solid fa-check"></i>
		</button>
		<button class="btn btn-standard" (click)="showFormFunc(false)">
			<i class='fa-regular fa-xmark'></i>
		</button>
	</common-button-row>
</div>

@for(email of emails(); track email.emailId) {
<div class="d-flex align-items-center justify-content-between my-2 gap-4">
	<button class="btn btn-standard" (click)="changePrimaryEmail(email.emailId)">
		<i class="fa-regular fa-star" [class.fa-solid]="email.isDefault"></i>
	</button>
	<span>{{email.email}}</span>
	<!-- Hide delete button but preserve layout spacing when email is primary -->
	<button class="btn btn-standard" [class.invisible]="email.isDefault" (click)="confirmEmailDeletion(email)">
		<i class="fa-regular fa-trash"></i>
	</button>
</div>
}
<div>

</div>